import { render, staticRenderFns } from "./VoteOnPost.vue?vue&type=template&id=690f136e&"
import script from "./VoteOnPost.vue?vue&type=script&lang=js&"
export * from "./VoteOnPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports